// extracted by mini-css-extract-plugin
export default {"myBtn":"ProductCartButton_myBtn__tirpo"};